// extracted by mini-css-extract-plugin
export default {"base":"SearchCriteria_base__GURUA","remove":"SearchCriteria_remove__p2d7i"};